<template>
  <v-container>
    <v-layout row wrap>
      <v-flex xs4 sm3>
        <ProfileSidebar active="subscription" />
      </v-flex>
      <v-flex xs7 sm8 offset-xs1>
        <h1>Subscription</h1>
        <br />
        <v-layout row wrap>
          <v-flex xs6 class="pr-2">
            <v-card>
              <v-card-title>
                <h2>
                  Current Package:
                  {{
                    application.subscriptionData.subscriptionPlan.package_name
                  }}
                </h2>
              </v-card-title>
              <v-card-text style="min-height: 80px">
                Your package expires in
                {{ application.subscriptionData.subscriptionPlan.end_date }}
              </v-card-text>
              <v-card-actions>
                <v-btn
                  round
                  class="primary ml-2 mb-2"
                  @click="$router.push('/subscription-package')"
                >
                  Manage Subscription
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
          <v-flex xs6 class="pl-2">
            <v-card>
              <v-card-title>
                <h2>Collect data anywhere, any time</h2>
              </v-card-title>
              <v-card-text style="min-height: 80px">
                Power up your ability to collect data in the cloud with added
                speed and memory.
              </v-card-text>
              <v-card-actions>
                <v-btn
                  round
                  class="success ml-2 mb-2"
                  @click="$router.push('/subscription-package')"
                >
                  Upgrade Now
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
        <br />
        <br />
        <v-layout row wrap>
          <h2>Payment History</h2>
          <br />
          <br />
          <v-flex xs12>
            <v-data-table
              :headers="headers"
              :items="subscriptions"
              class="elevation-1"
            >
              <template v-slot:items="props">
                <td class="text-xs-center">{{ props.item.created_at }}</td>
                <td class="text-xs-right">{{ props.item.price }}</td>
                <td class="text-xs-center">Port-Pos</td>
                <td class="text-xs-center">
                  <a
                    target="_blank"
                    :href="props.item.url"
                    v-if="props.item.url"
                  >
                    Download
                  </a>
                  <span v-else>N/A</span>
                </td>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
  import ProfileSidebar from "../../components/profile/ProfileSidebar.vue";
  import api from "../../api/datadash";
  import { mapState } from "vuex";
  export default {
    components: {
      ProfileSidebar,
    },
    data() {
      return {
        headers: [
          {
            text: "Date",
            align: "center",
            value: "created_at",
          },
          {
            text: "Amount",
            align: "right",
            value: "price",
          },
          {
            text: "Payment Method",
            align: "center",
            sortable: false,
            value: "",
          },
          { text: "Invoice", align: "center", sortable: false, value: "url" },
        ],
        loading: false,
        subscriptions: [],
      };
    },
    computed: {
      ...mapState(["auth", "application"]),
    },
    created() {
      this.fetchSubscriptions();
    },
    methods: {
      async fetchSubscriptions() {
        this.loading = true;
        try {
          const { data } = await api.fetchData(
            this.auth.token,
            "subscription-history"
          );
          this.subscriptions = data.data.subscriptionHistory.data;
        } catch (e) {
          // console.log(e)
        }
      },
    },
  };
</script>
<style scoped>
  .align-left {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-left: -5px;
  }
</style>
